export const FF4ShopEntries = [
  { name: 'Baron', color: 'text-earth-shop' },
  { name: 'Mist', color: 'text-earth-shop' },
  { name: 'Kaipo', color: 'text-earth-shop' },
  { name: 'Fabul', color: 'text-earth-shop' },
  { name: 'Mysidia', color: 'text-earth-shop' },
  { name: 'Toroia', color: 'text-earth-shop' },
  { name: 'Silvera', color: 'text-earth-shop' },
  { name: 'Agart', color: 'text-earth-shop' },
  { name: 'Eblan', color: 'text-earth-shop' },
  { name: 'Dwarf', color: 'text-underground-shop' },
  { name: 'Tomra', color: 'text-underground-shop' },
  { name: 'Feymarch', color: 'text-underground-shop' },
  { name: 'Smith', color: 'text-underground-shop' },
  { name: 'Moon', color: 'text-moon-shop' }
];
